


















































































import Vue from 'vue'
import FeaturedProject from '@/components/FeaturedProject.vue'
import FooterItem from '@/components/FooterItem.vue'
import HeaderPartners from '@/components/HeaderPartners.vue'
import Services from '@/components/Services.vue'
import Experiences from '@/components/Experiences.vue'
import Location from '@/components/Location.vue'
const carousel = require('v-owl-carousel')

export default Vue.extend({
  name: 'home',
  components: {
    FeaturedProject,
    FooterItem,
    HeaderPartners,
    Services,
    Experiences,
    Location,
    carousel
  },
  data: function () {
    return {
      HeaderPartners: {
        img: {
          src: 'assets/img/partners/simbiosys/simbiosys-logo.png',
          alt: 'Izertis es una consultora tecnológica que facilita la transformación digital de las organizaciones'
        },
        name: 'Simbiosystems S.L.',
        description: 'Expertos en diseño estratégico de producto digital. Definimos, diseñamos y desarrollamos soluciones multidispositivo y multiplataforma basadas en tecnologías web.'
      },
      services: {
        description: 'Definimos, diseñamos y desarrollamos soluciones multidispositivo y multiplataforma basadas en tecnologías web.',
        services: [
          {
            title: 'Diseño de experiencia de usuario (UX)',
            description: ''
          },
          {
            title: 'Portales y aplicaciones web',
            description: ''
          },
          {
            title: 'Aplicaciones móviles',
            description: ''
          },
          {
            title: 'Plataformas de gestión de información',
            description: ''
          },
          {
            title: 'Diseño gráfico profesional',
            description: ''
          },
          {
            title: 'Branding y estrategia de marca',
            description: ''
          },
          {
            title: 'Diseño de materiales de marketing',
            description: ''
          }
        ]
      },
      experiences: {
        experiences: [
          {
            number: '1',
            description: 'SIMBIOSYS es una compañía española del sector TIC especialista en el <strong class="font-bold">diseño estratégico de productos digitales</strong>. Su diferencia competitiva radica en la conjugación del diseño y la tecnología, con un equipo senior de personas que acumulan muchos años de experiencia trabajando en las áreas de diseño centrado en el usuario, web, diseño gráfico y Rich Internet Applications. Se trata de una plantilla con perfil multidisciplinar, formada por personas que conocen la tecnología pero que también tienen formación específica en disciplinas con el diseño, el arte, la publicidad y el marketing, entre otras. Esta doble vertiente, que <strong class="font-bold">combina la tecnología y el diseño</strong> se ha erigido como el valor añadido fundamental de la empresa, un valor que alimentan a través de la formación continua.'
          },
          {
            number: '2',
            description: 'Además, cuenta con un equipo cada vez mayor de empresas y profesionales independientes. Entre sus socios más destacados se encuentran, grandes empresas dedicadas al desarrollo de tecnología, productoras y profesionales del mundo audiovisual, locutores profesionales, compositores, ilustradores y fotógrafos; pedagogos, psicólogos, sociólogos y antropólogos.'
          }
        ]
      },
      projects: [
        {
          title: ' World Wide Web Foundation',
          img: {
            src: 'assets/img/projects/web-foundation.jpg',
            alt: ' World Wide Web Foundation'
          },
          description:
            'proyecto para la organización dedicada a la mejora y disponibilidad de la World Wide Web'
        },
        {
          title: 'Land Portal',
          img: {
            src: 'assets/img/project-1.png',
            alt: 'Proyecto: Land Portal'
          },
          description:
            'Fundación Land Portal. Coalición Internacional de la Tierra. Plataforma Global de Donantes para el Desarrollo Rural.'
        },
        {
          title: 'Alliance for Affordable Internet (A4AI)',
          img: {
            src: 'assets/img/project-3.png',
            alt: 'Alliance for Affordable Internet (A4AI)'
          },
          description:
            'Es una coalición global que trabaja para reducir el costo del acceso a internet en países en vías de desarrollo'
        }
      ],
      location: {
        url: 'https://www.google.es/maps/place/Simbiosys/@43.522587,-5.613567,17z/data=!3m1!4b1!4m5!3m4!1s0xd367b19837fcf51:0xb3adf41b77fc354d!8m2!3d43.522587!4d-5.611373',
        img: {
          src: 'assets/img/maps/simbiosys-map.png',
          alt: 'Localización de Simbiosystems S.L.'
        },
        adress: 'Parque Científico Tecnológico de Gijón - C/Profesor Potter, 183. 2ª Planta.33203 Gijón, Asturias - España'
      }
    }
  }
})
